module.exports = "data:application/octet-stream;base64,QGltcG9ydCAic2hhcmVkLnNjc3MiOwoKLkVycm9yQm94IHsKICAgIGJhY2tncm91bmQ6IHdoaXRlOwp9Ci5UaXRsZSB7CiAgICBmb250LXNpemU6IDIwcHg7CiAgICBjb2xvcjogYmxhY2s7Cn0KLk1lc3NhZ2UgewogICAgZm9udC1zaXplOiAxNXB4OwogICAgY29sb3I6IGJsYWNrOwp9CgouRXJyb3JEZXRhaWxzIHsKICAgIGZvbnQtc2l6ZTogMTJweDsKICAgIGNvbG9yOiAjMjkzOTNlOwp9CgouVW5BdXRob3JpemVkSGVhZGVyIHsKICAgIGJhY2tncm91bmQ6ICRSZWQ7CiAgICBwYWRkaW5nOiAycmVtOwogICAgcGFkZGluZy1ib3R0b206IDNyZW07Cn0KCi5VbkF1dGhvcml6ZWRIZWFkZXJUZXh0IHsKICAgIHRleHQtYWxpZ246IGxlZnQ7Cn0="


//////////////////
// WEBPACK FOOTER
// ./src/components/invite/InviteUserError.scss
// module id = 1519
// module chunks = 0